import { useGetBcProductsQuery } from '@api/warranty.api';
import { useMemo } from 'react';

export const useBCProducts = (selectedProductType?: string) => {
  const { currentData, isLoading } = useGetBcProductsQuery();

  const productTypes = useMemo(
    () =>
      currentData?.map((item) => ({
        label: item.productType,
        value: item.productType,
      })) || [],
    [currentData]
  );

  const productModels = useMemo(
    () =>
      currentData?.find((item) => item.productType === selectedProductType)?.productModels || [],
    [currentData, selectedProductType]
  );

  return { productModels, productTypes, isLoading };
};
